import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Filter } from 'projects/Administration/src/app/business-entities/Filter';
import { PackageBOMResponseModel, PackageVersion, SearchPackageList } from 'projects/Administration/src/app/business-entities/package-list-model';
import { SearchPackageListRequestModel } from 'projects/Administration/src/app/business-entities/package-list-request-model';
import { PagerData } from 'projects/Administration/src/app/business-entities/PagerData';
import { PartDetailsViewModel } from 'projects/Administration/src/app/business-entities/part-details-view-model';
import { ServiceViewModel } from 'projects/Administration/src/app/business-entities/service-view-model';
import { BrandType } from 'projects/Administration/src/app/business-entities/vehicle-list-view-model';
import { BrandService } from 'projects/Administration/src/app/business-services/brand.service';
import { PackageService } from 'projects/Administration/src/app/business-services/package.service';
import { PaginationService } from 'projects/Administration/src/app/services/pagination.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { PartNumberModel, PartsListViewModel } from '../../../business-entities/parts-list-view-model';
import { PartsBusinessService } from '../../../business-services/parts.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-search-package',
  templateUrl: './search-package.component.html'
})
export class SearchPackageComponent implements OnInit {
  popupCloseResult = false;
  closeResult = '';
  brandCode: string;
  packageNumber: string = "";
  packageName: string = "";
  makeList: BrandType[] = [];
  allMakeList: BrandType[] = [];
  packageList: SearchPackageList[] = [];
  partModel: PartNumberModel;
  currentlagSub: Subscription;
  dealerPartList: PartDetailsViewModel[] = [];
  services: ServiceViewModel[] = [];
  partsList: PartsListViewModel[] = [];
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25//Constant.GridPagerSize
  }
  dataRows: any[] = [];
  pager: any = {};
  pagedItems: any[];
  filterItems: any[];
  filter: Filter = new Filter();
  throttle = 100;
  scrollDistance = 1;
  isDealerSpeficPackage:boolean = false;
  isDmsPlannerPackage:boolean = false;
  subscription : Subscription;
  allowDealerBrandLaborRate: boolean = false;

  @Input() companyMakeCode:string=null;
  searchPackageListRequestModel: SearchPackageListRequestModel =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      cultureCode: '',
      makeCode: '',
      no: '',
      name: '',
      sourceId:0,
      dealerId:'',
      isDealerSpeficPackage:false,
      isDmsPlannerPackage:false
    }
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(private spinner: NgxSpinnerService,
    public service: PackageService,
    private activeModal: NgbActiveModal,
    private brandService: BrandService,
    private toastr: ToastrService,
    private translate: TranslateService,
    public pService: CustomPaggerService,
    private cookieservice: CookieService,
    private pagerService: PaginationService,
    private partService: PartsBusinessService,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['packageNumber', 'packageNameEn', 'packageNameNl', 'packageNameNo'];
    this.pService.searchTerm = '';
  }

  ngOnInit(): void {
    this.isDealerSpeficPackage = localStorage.getItem("Theme") === 'mg';
    this.isDmsPlannerPackage = localStorage.getItem("Theme") === 'bnh';
    
    this.GetAllMake();
    this.getFeatures();
    this.packageList = [];
    this.searchPackageListRequestModel.cultureCode = this.cookieservice.get('userSelectedLanguage');
    this.searchPackageListRequestModel.startRecordNumber = 0;
    if(this.isDmsPlannerPackage){
      if(this.service.appointmentType == "Quote" || this.service.isFromAdditionalWork){
        this.searchPackageListRequestModel.sourceId = 1;
      }
    }else if(this.isDealerSpeficPackage){
      this.searchPackageListRequestModel.sourceId = 0;
    }
  }

  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if(features == null || features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        features = res;
        if (features?.length > 0) {
          this.allowDealerBrandLaborRate = features.find(x => x.featureCode === fromEnums.FeatureCode.AllowDealerBrandLaborRate)?.isActive ?? false;
        }
      })
    }else{
        this.allowDealerBrandLaborRate = features.find(x => x.featureCode === fromEnums.FeatureCode.AllowDealerBrandLaborRate)?.isActive ?? false;
    }
  }

  async GetAllMake(): Promise<void> {
    let vehicleMakeCode=this.companyMakeCode ? this.companyMakeCode : null;
    await this.brandService.GetServiceBrandDropdownList(vehicleMakeCode).then(data => {
      this.makeList = data.responseObject;
    });
  }

  ngOnDestroy(): void {
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.service.isFromAdditionalWork = false;
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  async onSearchPackage() {
    if (this.empty(this.brandCode) && this.empty(this.packageName) && this.empty(this.packageNumber)) {
      let ServiceNotFound = this.translate.instant("lblRequiredPartEntry");
      this.toastr.error(ServiceNotFound);
      return;
    }
    this.packageList = [];
    this.searchPackageListRequestModel.makeCode = this.empty(this.brandCode) ? "" : this.brandCode;
    this.searchPackageListRequestModel.name = this.empty(this.packageName) ? "" : this.packageName;
    this.searchPackageListRequestModel.no = this.empty(this.packageNumber) ? "" : this.packageNumber;
    this.searchPackageListRequestModel.dealerId = this.empty(this.service.dealerId) ? "" : this.service.dealerId;
    this.searchPackageListRequestModel.isDealerSpeficPackage = this.isDealerSpeficPackage;
    this.searchPackageListRequestModel.isDmsPlannerPackage = this.isDmsPlannerPackage;

    this.getSearchPackage();
  }
  async getSearchPackage() {
    this.spinner.show();
    await this.service.getSearchPackage(this.searchPackageListRequestModel).then(response => {
      this.spinner.hide();
      this.packageList.push(...this.PackageDataMapper(response.responseObject));
      if (response.responseObject?.result?.errorCode == "5449") {
        this.totalCount = 0;
      }
      else {
        this.totalCount = this.packageList.length > 0 ? this.packageList[0].totalCount : 0;
      }
      this.resetPagerData(this.supplierInitiliseGridFromServer(this.packageList, this.totalCount));
      if (this.pagerData.page > 1) {
        this.resetPagerData(this.initilisePagerFromServer(this.pagerData.page, this.pagerData.pagerSize, this.totalCount));
      }
    }, _error => {
      this.spinner.hide()
    });
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  initilisePagerFromServer(page: number, _pageSize: number, count: number = this.filterItems.length) {
    let length = this.filterItems.length <= Constant.GridPagerSize ? Constant.GridPagerSize : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems; // .slice(this.pager.startIndex, this.pager.endIndex + 1);
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = (data.length === 0) ? 0 : 1;
    return this.initilisePagerFromServer(this.filter.page, Number(this.filter.pageSize), count);
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.searchPackageListRequestModel.sortColumn = column;
    this.searchPackageListRequestModel.sortDirection = direction;
    this.searchPackageListRequestModel.startRecordNumber = 0;
    this.searchPackageListRequestModel.dealerId = this.empty(this.service.dealerId) ? "" : this.service.dealerId;
    this.searchPackageListRequestModel.isDealerSpeficPackage = this.isDealerSpeficPackage;
    this.searchPackageListRequestModel.isDmsPlannerPackage = this.isDmsPlannerPackage;
    this.packageList = []
    this.getSearchPackage();
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.packageList.length) {
      this.searchPackageListRequestModel.startRecordNumber = this.packageList.length;
      this.getSearchPackage();
    }
  }

  private PackageDataMapper(manualList: SearchPackageList[]) {
    let supperArray = [];

    if (manualList && manualList.length > 0) {

      manualList.forEach(element=>{

        let single = Object();
        single.id = element.id;
        single.packageNo = element.packageNo;
        single.name = element.name;
        single.noOfVersion = element.noOfVersion;
        single.makeCode = element.makeCode;
        single.sourceTypeId = element.sourceTypeId;
        single.isPackageSelected = false;
        single.expanded = false;
        single.packageVersionList = [];
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onPackageChange(i) {
    for (let value of this.packageList) {
      value.isPackageSelected = false;
    }
    this.packageList[i].isPackageSelected = true;
  }

  onPackageVersionChange(i, j) {

    for (let value of this.packageList) {
      value.isPackageSelected = false;
    }
    this.packageList[i].isPackageSelected = true;
    for (let value of this.packageList[i].packageVersionList) {
      value.isPackageVersionSelected = false;
    }
    this.packageList[i].packageVersionList[j].isPackageVersionSelected = true;
  }
  async getPackageVersion(packageId, i) {
    if (this.packageList[i].expanded) {
      return;
    }
    this.spinner.show();

    await this.service.GetPackageVersionByPackageNo(packageId, this.cookieservice.get('userSelectedLanguage')).then(response => {
      this.packageList[i].packageVersionList = this.PackageVersionDataMapper(response.responseObject);
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  private PackageVersionDataMapper(manualList: PackageVersion[]) {
    let supperArray = [];

    if (manualList && manualList.length > 0) {

      manualList.forEach(element=>{ 
        let single = Object();
        single.id = element.id;
        single.makeCode = element.makeCode;
        single.name = element.name;
        single.packageId = element.packageId;
        single.packageNumber = element.packageNumber;
        single.packageVersionNumber = element.packageVersionNumber;
        single.noOfLine = element.noOfLine;
        single.isPackageVersionSelected = false;
        single.expandedVersion = false;
        single.packageBOMList = [];
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  async getPackageBOM(packageId, packageVersionId, i, j) {
    if (this.packageList[i].packageVersionList[j].expandedVersion) {
      return;
    }
    this.spinner.show();

    await this.service.GetPackageBOMByPackageNo(packageId, packageVersionId, this.service.dealerId,this.allowDealerBrandLaborRate).then(response => {
      this.packageList[i].packageVersionList[j].packageBOMList = this.PackageBOMDataMapper(response.responseObject);
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  private PackageBOMDataMapper(manualList: PackageBOMResponseModel[]) {
    let supperArray = [];
    if (manualList && manualList.length > 0) {
      manualList.forEach(element=>{ 
        let single = Object();
        single.id = element.id;
        single.packageId = element.packageId;
        single.packageVersionId = element.packageVersionId;
        single.makeCode = element.makeCode;
        single.packageNumber = element.packageNumber;
        single.packageVersionNumber = element.packageVersionNumber;
        single.lineNo = element.lineNo;
        single.bomTypeId = element.bomTypeId;
        single.typeName = element.typeName;
        single.costType = element.costType;
        single.no = element.no;
        single.description = element.description;
        single.quantity = element.quantity;
        single.unitPrice = element.unitPrice;
        single.serviceId = element.serviceId;
        single.unitofMeasureCode = element.unitofMeasureCode;

        if (element.bomTypeId == 1) {
          if (this.service.dealerServicesList.findIndex(x => x.serviceNo == element.no) != -1) {
            let dservice = this.service.dealerServicesList.find(x => x.serviceNo == element.no);
            single.serviceId = dservice.id;
            single.unitPrice = dservice.unitPrice;
            single.quantity = dservice.duration;
          }
        }
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  async onSavePackage() {
    let record = this.packageList.filter(x => x.isPackageSelected);
    if (record.length == 0) {
      let ServiceNotFound = this.translate.instant("lblRequiredPackageSelect");
      this.toastr.info(ServiceNotFound);
      return;
    }
    let _noOfversion = record[0].noOfVersion;
    if (_noOfversion == 0) {
      let ServiceNotFound = this.translate.instant("lblInvalidPackageVersion");
      this.toastr.info(ServiceNotFound);
    } else if (_noOfversion > 1) {
      let versionRecord = record[0].packageVersionList.length > 0 ? (record[0].packageVersionList.filter(x => x.isPackageVersionSelected)) : record[0].packageVersionList;
      if (versionRecord.length == 0) {
        let VersionNotFound = this.translate.instant("lblRequiredPackageVersion");
        this.toastr.info(VersionNotFound);
        return;
      } else {
        this.getBomDetails(record[0].packageVersionList.find(f => f.isPackageVersionSelected),record[0].makeCode,record[0].sourceTypeId);
      }
    } else if (_noOfversion == 1) {
      this.spinner.show();
      let index = this.packageList.findIndex(f => f.packageNo == record[0].packageNo);
      await this.service.GetPackageVersionByPackageNo(record[0].id, this.cookieservice.get('userSelectedLanguage')).then(response => {
        this.packageList[index].packageVersionList = this.PackageVersionDataMapper(response.responseObject);
        this.packageList[index].packageVersionList[0].isPackageVersionSelected = true;

        this.getBomDetails(this.packageList[index].packageVersionList.find(f => f.isPackageVersionSelected),record[0].makeCode,record[0].sourceTypeId);
      });

    }
  }
  async getBomDetails(packageVersionDetails: PackageVersion,packagemMakeCode: string,sourceId:number) {
    await this.service.GetPackageBOMByPackageNo(packageVersionDetails.packageId, packageVersionDetails.id,this.service.dealerId,this.allowDealerBrandLaborRate).then(response => {
      this.spinner.hide();
      this.service.packageVersionBOM = this.PackageBOMDataMapper(response.responseObject);
      if (this.service.packageVersionBOM.length == 0) {
        let ServiceNotFound = this.translate.instant("lblRequiredPackageBOM");
        this.toastr.info(ServiceNotFound);
        return;
      }
      // if service found in package then check that service is available for dealer if yes then replace price .
      let isServiceFound = true;
      this.service.packageVersionBOM.forEach(element => {
        if (element.bomTypeId == 1) {
          if (this.service.dealerServicesList.findIndex(x => x.serviceNo == element.no) == -1) {
            isServiceFound = false;
          } else {
            let dservice = this.service.dealerServicesList.find(x => x.serviceNo == element.no);
            element.serviceId = dservice.id;
            element.unitPrice = dservice.unitPrice;
            element.quantity = dservice.duration;
          }
        }
      });
      if (!isServiceFound) {
        let ServiceNotFound = this.translate.instant("lblDealerPackageNoFound");
        this.toastr.info(ServiceNotFound);
        return;
      }
      // if part found in package then get real time price from part api.
      this.partService.partNumberModel = [];
      this.partsList = [];

      this.service.packageVersionBOM.forEach(element => {
        if (element.bomTypeId == 2) {

          this.partModel = { partNumber: element.no };
          this.partService.partNumberModel.push(this.partModel);
        }
      });
      this.service.packageMakeCode = packagemMakeCode;
      this.service.packageVersionName = packageVersionDetails.name;
      this.service.sourceId = sourceId;
     
      if (sourceId == Constant.PlannerSource && this.partService.partNumberModel.length > 0) {
        this.spinner.show();
        let model = {
          locationCode: this.partService.locationCode,
          partNumberModel: this.partService.partNumberModel,
          languageCode: this.cookieservice.get('userSelectedLanguage')
        }
        this.partService.GetPartDetails(model).then(response => {
          this.spinner.hide();
          this.partsList = response;
          if (this.partsList && this.partsList?.length > 0) {
            this.service.packageVersionBOM.forEach(element => {
              if (element.bomTypeId == 2) {
                let part = this.partsList.find(x => x.partNumber == element.no);
                  element.unitPrice = part.unitPrice;
                  element.totalQuantityOnLocal = part.quantity;
                  element.availableQuantity = part.availableQuantity;
                  element.centralTotalQty = part.centralTotalQty;
                  element.centralAvailableQty = part.centralAvailableQty;
              }
            });
          }
          this.activeModal.dismiss(true);
        });
      } else {
        this.activeModal.dismiss(true);
      }
    });
  }

  OnClose() {
    this.activeModal.dismiss(false);
  }

}
